import { POSTHOG_KEY } from "@pharaday/env";
import { getCookie } from "cookies-next/client";
import posthog, { type PostHog } from "posthog-js";

import { FeatureFlagContainer } from "../core";
import { COOKIE_BOOTSTRAP_POSTHOG } from "../core/infrastructure/feature-flag-service/posthog-feature-flag.service";

/**
 * Initializes the PostHog client with first-party proxy configuration.
 * Traffic is routed through `/hbr/` rewrites configured in each app's next.config.mjs,
 * which proxy requests to PostHog EU servers. This approach avoids CSP violations
 * and ad-blocker interference.
 */
export const PostHogClient = (): PostHog => {
  const bootstrapCookies = getCookie(COOKIE_BOOTSTRAP_POSTHOG);
  const bootstrap = bootstrapCookies && JSON.parse(bootstrapCookies);
  posthog.init(FeatureFlagContainer.get(POSTHOG_KEY), {
    api_host: "/hbr",
    ui_host: "https://eu.posthog.com",
    bootstrap,
    advanced_disable_feature_flags: true,
    advanced_disable_feature_flags_on_first_load: true,
    api_transport: "fetch",
  });

  return posthog;
};
